import {
    GET_POSTS_FACEBOOK,
    SET_NAME_POST,
    SET_CONTENT_POST,
    SET_URL_IMG_POST,
    SET_POST,
    SET_SELECTED_POSTS,
    OPEN_MODIFY_POPUP_POST,
    CLOSE_MODIFY_POPUP_POST,
    SET_UPDATE_BUTTON,
    SET_CREATE_BUTTON,
    SET_ID_POST_CURRENT,
} from '../../@jumbo/constants/ActionTypes';

const INIT_STATE = {
    dataPosts: [],
    namePost: '',
    contentPost: '',
    urlImg: [],
    selectedPosts: [],
    postRan: [],
    isOpenPopUpModify: false,
    isUpdateButton: false,
    idCurrentPost: '',
    dataCategory: [],
    chatgpt_key: "",
    is_chatgpt: false,
    content_chatgpt: "",
    isLoadedPosts: false,
    model_image_chatgpt: "",
    model_chatgpt: "",
    question_image_chatgpt: "",
    is_image_chatgpt: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_POSTS_FACEBOOK: {
            return {
                ...state,
                dataPosts: action.payload,
                isLoadedPosts: true
            };
        }
        case SET_POST: {
            return {
                ...state,
                namePost: action.payload.namePost ? action.payload.namePost : '',
                contentPost: action.payload.contentPost ? action.payload.contentPost : '',
                urlImg: action.payload.urlImg ? action.payload.urlImg : [],
                chatgpt_key: action.payload.chatgpt_key ? action.payload.chatgpt_key : "",
                is_chatgpt: !!action.payload.is_chatgpt,
                content_chatgpt: action.payload.content_chatgpt ? action.payload.content_chatgpt : "",
                question_image_chatgpt: action.payload.question_image_chatgpt || "",
                is_image_chatgpt: !!action.payload.is_image_chatgpt,
                model_chatgpt: action.payload.model_chatgpt || "",
                model_image_chatgpt: action.payload.model_image_chatgpt || ""
            };
        }
        case SET_NAME_POST: {
            return {
                ...state,
                namePost: action.payload,
            };
        }
        case SET_CONTENT_POST: {
            return {
                ...state,
                contentPost: action.payload,
            };
        }
        case SET_URL_IMG_POST: {
            return {
                ...state,
                urlImg: action.payload,
            };
        }
        case SET_SELECTED_POSTS: {
            return {
                ...state,
                selectedPosts: action.payload,
            };
        }
        case CLOSE_MODIFY_POPUP_POST: {
            return {
                ...state,
                isOpenPopUpModify: false,
            };
        }
        case OPEN_MODIFY_POPUP_POST: {
            return {
                ...state,
                isOpenPopUpModify: true,
            };
        }
        case SET_UPDATE_BUTTON: {
            return {
                ...state,
                isUpdateButton: action.payload,
            };
        }
        case SET_CREATE_BUTTON: {
            return {
                ...state,
                isUpdateButton: false,
            };
        }
        case SET_ID_POST_CURRENT: {
            return {
                ...state,
                idCurrentPost: action.payload,
            };
        }
        default:
            return state;
    }
};
